export const calculateDiscountedPrice = (price, discountPercentage) => {
    const discountAmount = (price * discountPercentage) / 100;
    const discountedPrice = price - discountAmount;
    return discountedPrice;
}

export const filterData = (subject, sub_type) => {
    const sub_filter = subject.filter((course) =>
        course.course_type === sub_type && course.willDisplay === true
    );
    return sub_filter;
}

export const sortData = (data) => {
    const sort_data = data.sort((a, b) =>
        a.display_priority - b.display_priority
    );
    return sort_data;
}

// export const calculateTimeUntilEndOfYear = () => {
//     const now = Date.now();
//     const endOfYear = new Date(new Date().getFullYear(), 11, 31, 23, 59, 59, 999).getTime();
//     return endOfYear - now;
// };

export const calculateTimeUntilEndOfYear = () => {
    const now = new Date();
    const year = now.getFullYear();
    const fixedAccessTill = new Date(`${year}-12-31T00:00:00Z`).getTime();
    return fixedAccessTill;
};

export const formatTimestampToDate = (timestamp) => {
    const date = new Date(timestamp);
    const day = String(date.getDate()).padStart(2, '0');     
    const month = String(date.getMonth() + 1).padStart(2, '0'); 
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
}
  

// export const cleanedString = (rawString) => {
//     const tempElement = document.createElement("div");
//     tempElement.innerHTML = rawString.replace(/<[^>]*>/g, ""); 
//     return tempElement.textContent.trim(); 
// };

export const cleanedString = (rawString) => {
  if (typeof rawString !== "string") return "";
  const tempElement = document.createElement("div");
  tempElement.innerHTML = rawString.replace(/<[^>]*>/g, "");
  return tempElement.textContent.trim();
};


export const calculateDiscountPercentage = (originalPrice, sellingPrice) => {
  if (originalPrice === 0) return 0;
  const discount = originalPrice - sellingPrice;
  const discountPercentage = (discount / originalPrice) * 100;
  return Math.floor(discountPercentage);
}

export const isOlderThan24Hours = (timestampMs) => {
  const now = Date.now(); 
  const diff = now - timestampMs;
  const twentyFourHours = 24 * 60 * 60 * 1000;
  return diff >= twentyFourHours;
};

export const expiryTime = (timestampMs) => {
  const now = Date.now(); 
  const twentyFourHours = 24 * 60 * 60 * 1000;
  const diff = now - timestampMs;
  const remaining = twentyFourHours - diff;
  return remaining;
};

// Future use

// export const msToHM = (milisec) => {
//     const date = new Date(milisec);
    
//     const hours = date.getHours().toString().padStart(2, '0'); // Local hours
//     const minutes = date.getMinutes().toString().padStart(2, '0');
    
//     console.log(`${hours}:${minutes}`); 
// }

